"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _menu = _interopRequireDefault(require("antd/lib/menu"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _AntdIcon = _interopRequireDefault(require("../antdIcon/AntdIcon"));

var _SideBar = _interopRequireDefault(require("./SideBar"));

const AdminSideBar = props => {
  const {
    collapsed
  } = props;
  return /*#__PURE__*/_react.default.createElement(_SideBar.default, {
    collapsed: collapsed
  }, /*#__PURE__*/_react.default.createElement(_menu.default, {
    id: "sidebar-menu",
    mode: "inline",
    theme: "dark",
    defaultSelectedKeys: ['/home']
  }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
    key: "/home",
    className: "sidebar-menu-item"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/admin"
  }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
    fontAwesomeIcon: _proSolidSvgIcons.faHome
  }), /*#__PURE__*/_react.default.createElement("span", null, "Home"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
    key: "/admin/users",
    className: "sidebar-menu-item"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/admin/users"
  }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
    fontAwesomeIcon: _proSolidSvgIcons.faUsers
  }), /*#__PURE__*/_react.default.createElement("span", null, "Users"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
    key: "/admin/studies",
    className: "sidebar-menu-item"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/admin/studies"
  }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
    fontAwesomeIcon: _proSolidSvgIcons.faMicroscope
  }), /*#__PURE__*/_react.default.createElement("span", null, "Studies"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
    key: "/admin/cms",
    className: "sidebar-menu-item"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/admin/cms"
  }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
    fontAwesomeIcon: _proSolidSvgIcons.faFilesMedical
  }), /*#__PURE__*/_react.default.createElement("span", null, "CMS"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
    key: "/settings",
    className: "sidebar-menu-item"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/admin/settings"
  }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
    fontAwesomeIcon: _proSolidSvgIcons.faCogs
  }), /*#__PURE__*/_react.default.createElement("span", null, "Settings")))));
};

const mapStateToProps = state => {
  const {
    sidebar
  } = state.ui;
  return {
    collapsed: sidebar.collapsed
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AdminSideBar);

exports.default = _default;